















import Vue from 'vue';
import { User, ListElement } from '../types';
import AccountContextMixin from '../account/AccountContextMixin';
import UsersTable from './UsersTable.vue';
import InviteUserBtn from './invite/InviteUserBtn.vue';

export default Vue.extend({
  components: { UsersTable, InviteUserBtn },
  mixins: [AccountContextMixin],
  methods: {
    unshift(user: User) {
      (this.$refs.users as ListElement).unshift(user);
    },
  },
});
